// Generic sort helpers shared across frontend pages

export const SORT_DIRECTIONS = ['asc', 'desc'] as const;
export type SortDirection = (typeof SORT_DIRECTIONS)[number];

export const toTimestamp = (
  value: Date | string | number | undefined
): number => {
  if (value instanceof Date) {
    return value.getTime();
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  return 0;
};

export const applySortDirection = (
  result: number,
  direction: SortDirection
): number => (direction === 'asc' ? result : -result);
